"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _expandHorizontal = _interopRequireDefault(require("@atlaskit/icon/core/expand-horizontal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EditorMediaFullWidthIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 17h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2M4 5h16a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
}, props, {
  newIcon: _expandHorizontal.default
}));
EditorMediaFullWidthIcon.displayName = 'EditorMediaFullWidthIcon';
var _default = exports.default = EditorMediaFullWidthIcon;